"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopMunicipalities = void 0;
var Backbone = __importStar(require("backbone"));
var underscore_1 = __importDefault(require("underscore"));
var TopMunicipalities = /** @class */ (function (_super) {
    __extends(TopMunicipalities, _super);
    function TopMunicipalities() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopMunicipalities.prototype.initialize = function () {
        this.model.bind('change:top', this.render, this);
    };
    TopMunicipalities.prototype.render = function () {
        var top = this.model.top();
        var html = top
            ? TopMunicipalities.template({ municipalities: this.model.top() })
            : '';
        this.$el.html(html);
        return this;
    };
    TopMunicipalities.template = underscore_1.default.template("\n    <h2>De b\u00E4sta kommunerna inom denna kategori</h2>\n    <ul>\n      <% for (var i = 0; i < municipalities.length; i++) { %>\n        <li>\n          <img src=\"/assets/arms/<%= municipalities[i].slug %>.png\" height=\"65\">\n          <div>\n            <span><%= municipalities[i].name %></span>\n            <a href=\"/<%= municipalities[i].slug %>\">\n              Visa ranking <i class=\"fa fa-arrow-right\"></i>\n            </a>\n          </div>\n        </li>\n      <% } %>\n    </ul>\n  ");
    return TopMunicipalities;
}(Backbone.View));
exports.TopMunicipalities = TopMunicipalities;
